import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["button"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { memo } from 'react';
import { useOnScreenEffect } from '@beef/utils';
import { useAnalyticsLinks } from "../hooks/useAnalyticsLinks";
import { AnalyticsPusherInfo, AnalyticsPusherTeaser } from "../utils/analytics";
export var withAnalyticsBanner = function withAnalyticsBanner(WrappedComponent, type) {
  return /*#__PURE__*/memo(function (_ref) {
    var button = _ref.button,
      props = _objectWithoutProperties(_ref, _excluded);
    var ref = useOnScreenEffect(function () {
      if (type === 'info') {
        AnalyticsPusherInfo.pushViewEvent(button === null || button === void 0 ? void 0 : button.link);
      }
    }, []);
    useAnalyticsLinks(ref, props.blockIndex);
    var handleClick = function handleClick(val) {
      if (type === 'info') {
        var _button$onClick;
        AnalyticsPusherInfo.pushClickEvent(button === null || button === void 0 ? void 0 : button.link);
        AnalyticsPusherInfo.pushReachGoal(button === null || button === void 0 ? void 0 : button.link, props.blockIndex);
        button === null || button === void 0 ? void 0 : (_button$onClick = button.onClick) === null || _button$onClick === void 0 ? void 0 : _button$onClick.call(button, val);
      }
      if (type === 'teaser') {
        var _button$onClick2;
        AnalyticsPusherTeaser.pushClickEvent(button === null || button === void 0 ? void 0 : button.link);
        AnalyticsPusherTeaser.pushReachGoal(button === null || button === void 0 ? void 0 : button.link, props.blockIndex);
        button === null || button === void 0 ? void 0 : (_button$onClick2 = button.onClick) === null || _button$onClick2 === void 0 ? void 0 : _button$onClick2.call(button, val);
      }
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      ref: ref
    }, props, {
      button: _objectSpread(_objectSpread({}, button), {}, {
        onClick: handleClick
      }),
      "data-t-id": "src-hocs"
    }));
  });
};